<template>
    <span class="cmn-filter-func">
        <span v-if="editable">
            <template v-if="argParts.length > 0" v-for="(argPart, index) in argParts">
                <el-input :title="argTypeNames[argPart]" @change="triggerChange(argPart)" style="width:40px;display: inline-block;margin-left:2px;margin-right:2px;" v-if="typeof  argPart =='number'"
                          v-model="argValMap['value:' + argPart]"></el-input>
                <span v-else="">{{ argPart }}</span>
            </template>
        </span>
        <span v-else="">
            <template v-if="argParts.length > 0" v-for="(argPart, index) in argParts">
                <span v-if="typeof  argPart =='number'" style="margin-left:2px;margin-right:2px;"></span>
                <span v-else="">{{ argPart }}</span>
            </template>
        </span>
    </span>
</template>

<script>
    import { Utils } from '../../app.base'

    import { toJavaShortTypeName } from './Cmn'

    //
    function castStrValueByType(strVal, typeName) {
        if(strVal == null) {
            return null;
        }
        strVal = strVal + '';
        //
        let listFlagIndex = typeName.lastIndexOf('[');
        let listFlag = listFlagIndex > 0;
        if(listFlag) {
            typeName = typeName.substring(0, listFlagIndex).trim();
            //
            strVal = strVal.trim();
            //
            if(!strVal.startsWith('[') || !strVal.endsWith(']')) {
                return null;
            }
            let listVals = strVal.substring(1, strVal.length - 1).split(',');
            for(let i = 0, c = listVals.length; i < c; i++) {
                listVals[i] = castStrValueByType(listVals[i], typeName);
            }
            return '[' + listVals.join(', ') + ']';
        }
        else if(typeName != 'string') {
            strVal = strVal.trim();
        }
        //
        if(typeName == 'integer') {
            return Utils.ParseInt(strVal);
        }
        else if(typeName == 'float') {
            return Utils.ParseFloat(strVal);
        }
        else if(typeName == 'boolean') {
            return strVal == 'true';
        }
        else if(typeName == 'date') {
            let date = Date.parseAsDate(strVal);
            return date == null || isNaN(date) ? null : date.format('yyyy-MM-dd');
        }
        return strVal;
    }

    //{0}的前{1}位
    function parseFuncDispTpl(curFuncInfo) {
        curFuncInfo = curFuncInfo || {};
        //
        let argCount = curFuncInfo.argCount || 0;
        let dispTpl = curFuncInfo.dispTpl || '';
        //console.log(dispTpl);
        let tplParts = [];
        if(argCount > 0) {
            let xReg = /\{\d+}?/mg;
            let xArr = null;
            let lastEndIndex = -1;
            while((xArr = xReg.exec(dispTpl)) != null) {
                let matched = xArr[0];
                //console.log(matched);
                let startIndex = xArr.index;
                let endIndex = startIndex + matched.length;
                if(lastEndIndex != -1) {
                    tplParts.push(dispTpl.substring(lastEndIndex, startIndex));
                }
                lastEndIndex = endIndex;
                let matchedTmp = matched.trim();
                //参数索引占位符{?}
                let argIndex = Utils.ParseInt(matchedTmp.substring(1, matchedTmp.length - 1));
                if(argIndex != null && argIndex < argCount) {//暂时不处理可变参数
                    //忽略第一个参数
                    tplParts.push(argIndex == 0 ? '' : argIndex);
                }
                else {
                    tplParts.push(matched);
                }
            }
            if(lastEndIndex < dispTpl.length && dispTpl.length > 0) {
                if(lastEndIndex < 0) {
                    lastEndIndex = 0;
                }
                tplParts.push(dispTpl.substring(lastEndIndex));
            }
        }
        return tplParts;
    }

    export default {
        name: 'swb-cmn-filter-func',
        desc: '通用过滤函数参数设置',
        props: {
            filterFunc: {//{dispTpl, argCount, argTypeNames, args}
                type: Object
            },
            editable: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                argCount: 0,
                //
                argTypeNames: [],
                //
                argParts: [],
                //
                argValMap: {}
            };
        },
        watch: {
            filterFunc(newVal, oldval) {
                this.initData();
            }
        },
        mounted() {
            this.initData();
        },
        beforeDestroy() {
            //data
            this.argTypeNames = null;
            this.argParts = null;
            this.argValMap = null;
            //props
            this.filterFunc = null;
        },
        methods: {
            initData() {
                let filterFunc = this.filterFunc || {};
                let curFuncInfo = Utils.merge({}, filterFunc) || {};
                //
                this.argCount = curFuncInfo.argCount || 0;
                let srcTypeNames = curFuncInfo.argTypeNames || [];
                let argTypeNames = [];
                for(let i = 0, c = this.argCount; i < c; i++) {
                    let srcTypeName = i < srcTypeNames.length ? srcTypeNames[i] : 'string';
                    argTypeNames[i] = toJavaShortTypeName(srcTypeName);
                }
                console.log(argTypeNames);
                this.argTypeNames = argTypeNames;
                //
                this.argParts = parseFuncDispTpl(curFuncInfo);
                let argValMap = {};
                let args = curFuncInfo.args || [];
                for(let i = 0, c = args.length; i < c; i++) {
                    let argIndex = i + 1;//无第一次参数
                    let argTypeName = argTypeNames[argIndex];
                    argValMap['value:' + argIndex] = castStrValueByType(args[i], argTypeName);
                }
                this.argValMap = argValMap;
            },
            triggerChange(argIndex) {
                let argValMap = this.argValMap;
                let argValue = argValMap['value:' + argIndex];
                let argTypeName = this.argTypeNames[argIndex];
                //
                //console.log(argIndex, argTypeName, argValue);
                argValue = castStrValueByType(argValue, argTypeName);
                argValMap['value:' + argIndex] = argValue == null ? null : argValue + '';
                //console.log(argIndex, argTypeName, argValue);
                this.$emit('func-param-change');
            },
            //注意：验证不过则返回元婴
            validate() {
                let argCount = this.argCount;
                if(argCount == 0) {
                    return true;
                }
                //
                let argValues = this.getData();
                for(let i = 0, c = argValues.length; i < c; i++) {
                    let argValue = argValues[i];
                    if(Utils.isNoB(argValue)) {
                        return ('第 ' + (i + 1) + ' 参数尚未指定');
                    }
                }
            },
            getData() {
                let argCount = this.argCount;
                let argValMap = this.argValMap;
                let argValues = [];
                for(let i = 1; i < argCount; i++) {
                    let argValue = argValMap['value:' + i];
                    argValues[i - 1] = argValue;
                }
                return argValues;
            }
        }

    }


</script>

<style>
    .cmn-filter-func input[type=TEXT] {
        text-align: center;
        color: navy;
        height: 22px;
    }
</style>



// WEBPACK FOOTER //
// src/compo/ctrl/CmnFilterFuncParam.vue